var map = {
	"./Courses-placehold.jpg": 2992,
	"./Courses-placeholder copy 10.jpg": 815,
	"./Courses-placeholder copy 11.jpg": 8146,
	"./Courses-placeholder copy 12.jpg": 1053,
	"./Courses-placeholder copy 13.jpg": 6480,
	"./Courses-placeholder copy 14.jpg": 8131,
	"./Courses-placeholder copy 15.jpg": 9606,
	"./Courses-placeholder copy 16.jpg": 7377,
	"./Courses-placeholder copy 17.jpg": 3652,
	"./Courses-placeholder copy 18.jpg": 7479,
	"./Courses-placeholder copy 19.jpg": 5322,
	"./Courses-placeholder copy 2.jpg": 6704,
	"./Courses-placeholder copy 3.jpg": 4797,
	"./Courses-placeholder copy 4.jpg": 8454,
	"./Courses-placeholder copy 5.jpg": 6867,
	"./Courses-placeholder copy 6.jpg": 644,
	"./Courses-placeholder copy 7.jpg": 4241,
	"./Courses-placeholder copy 8.jpg": 3866,
	"./Courses-placeholder copy 9.jpg": 5799,
	"./Courses-placeholder copy.jpg": 6090,
	"./Courses-placeholder.jpg": 7169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5103;